import React, { useState, useEffect } from 'react';

const OfflineIndicator = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showIndicator, setShowIndicator] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowIndicator(true);
      // Hide the indicator after 3 seconds
      setTimeout(() => setShowIndicator(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowIndicator(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Reduced cache checking for performance (only in development)
    if (process.env.NODE_ENV === 'development' && 'serviceWorker' in navigator && 'caches' in window) {
      // Delay cache check to avoid immediate load
      setTimeout(() => {
        caches.open('wedding-photos-cache').then(cache => {
          return cache.keys();
        }).then(requests => {
          if (requests.length > 0) {
            console.log(`📱 ${requests.length} photos cached for offline viewing`);
          }
        }).catch(() => {
          // Silent fail to avoid performance impact
        });
      }, 5000); // Check after 5 seconds to avoid initial load impact
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showIndicator) return null;

  return (
    <div
      className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-50 px-4 py-2 rounded-full shadow-lg border transition-all duration-300 ${
        isOnline
          ? 'bg-green-50 text-green-800 border-green-200'
          : 'bg-orange-50 text-orange-800 border-orange-200'
      }`}
    >
      <div className="flex items-center space-x-2">
        <div
          className={`w-2 h-2 rounded-full ${
            isOnline ? 'bg-green-500' : 'bg-orange-500'
          }`}
        ></div>
        <span className="text-sm font-medium">
          {isOnline ? 'Back online - syncing data' : 'Offline mode - cached photos available'}
        </span>
      </div>
    </div>
  );
};

export default OfflineIndicator;
